<section>
    <div class="header">
        <h2>{{ pageData.pageHeader }}</h2>
        <p class="header-text">{{ pageData.pageDescription }}</p>
    </div>
    <div class="search-country">
        <label for="search country">{{ pageData.searchBoxLabel }}</label>
        <xm-search class="search" (countryDetails)="setSelectedCountry($event)"
            [textBoxPlaceHolder]="pageData.searchBoxPlaceholder"></xm-search>
    </div>
    <div *ngIf="hasSelectedCountry">
        <div class="not-found" *ngIf="!countryFound">
            <xm-media-image class="not-found-icon" [imageOptions]="notFoundIcon" size="width"></xm-media-image>
            <p class="not-found-disclaimer" *ngIf="!countryFound">{{ pageData.notFoundDisclaimer }}</p>
        </div>
    </div>
    <div *ngIf="!hasSelectedCountry || (hasSelectedCountry && countryFound)">
        <xm-call-rates-details [pageData]="pageData" [rateDetails]="rateDetails" [mexCanData]="mexCanData"
            (mexCanLauncher)="addAddon()"></xm-call-rates-details>
    </div>
    <button class="xm-btn-primary-light cta" (click)="gotItCta()">{{ pageData.cta }}</button>
</section>